import { Button } from '@mantine/core';
import { useUnit } from 'effector-react';
import { FileSearch } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { accountTreeModel } from 'entities/account/model';
import cls from './account-tree-empty.module.scss';

export const AccountTreeEmpty = () => {
	const { t } = useTranslation();
	const reset = useUnit(accountTreeModel.treeForm.reset);

	return (
		<div className={cls.accountTreeEmpty}>
			<div className={cls.accountTreeEmptyIcon}>
				<FileSearch />
			</div>
			<div className={cls.accountTreeEmptyGroup}>
				<div className={cls.accountTreeEmptyTitle}>{t('account-tree.empty.title')}</div>
				<div className={cls.accountTreeEmptyMessage}>{t('account-tree.empty.message')}</div>
			</div>
			<Button
				variant='outline'
				onClick={reset}
			>
				{t('account-tree.empty.button')}
			</Button>
		</div>
	);
};
